import { render, staticRenderFns } from "./FullMasterTemplate.vue?vue&type=template&id=3a87116f"
import script from "./FullMasterTemplate.vue?vue&type=script&lang=js"
export * from "./FullMasterTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports